/// <amd-module name="DistributedTaskUI/Logs/LogsSummaryView" />
import * as React from "react";

import { ILogLine } from "DistributedTaskUI/Logs/Logs.Types";
import { LogLine } from "DistributedTaskUI/Logs/LogLine";

import { css } from "VSSUI/Util";

import "VSS/LoaderPlugins/Css!DistributedTaskUI/Logs/LogsSummaryView";

export interface ILogsSummaryViewProps {
    logLines: ILogLine[];
    cssClass?: string;
    maxLogs?: number;
    fixedHeight?: boolean;
    showSectionIcons?: boolean;
    onNavigateToLog?: (lineNumber?: number) => void;
}

const c_allowedMaxLogs = 500;
const c_defaultMaxLogs = 50;
const c_lineHeight = 18;
const c_padding = 10;

export class LogsSummaryView extends React.Component<ILogsSummaryViewProps, {}> {

    public render(): React.ReactNode {
        if (this.props.maxLogs && this.props.maxLogs > c_allowedMaxLogs) {
            throw new Error("A maximum of " + c_allowedMaxLogs + " lines of logs are allowed.");
        }

        let logLines: ILogLine[] = this.props.logLines;
        const maxLogs = this.props.maxLogs ? this.props.maxLogs : c_defaultMaxLogs;
        const logsContainerDivStyle = this._getContainerDivStyle(maxLogs);

        if (logLines.length > maxLogs) {
            logLines = logLines.slice(logLines.length - maxLogs, logLines.length);
        }

        return (
            <div className={css("dtc-logs-summary", this.props.cssClass)} ref={"_parentElement"} style={logsContainerDivStyle}>
                {
                    logLines.map((logLine: ILogLine, index: number) => {
                        return (
                            <LogLine onNavigateToLog={this.props.onNavigateToLog} key={index} showSectionIcons={this.props.showSectionIcons} logLine={logLine} />
                        );
                    })
                }
            </div>
        );
    }

    public componentDidUpdate() {
        if (this._parentElement) {
            this._parentElement.scrollTop = this._parentElement.scrollHeight;
        }
    }

    private _getContainerDivStyle(maxLogs: number): React.CSSProperties {
        const logsContainerDivStyle: React.CSSProperties = {
            lineHeight: c_lineHeight + "px",
            padding: c_padding + "px"
        };

        if (this.props.fixedHeight) {
            logsContainerDivStyle["height"] = ((maxLogs * c_lineHeight) + (c_padding));
        }

        return logsContainerDivStyle;
    }

    private _parentElement: HTMLElement;
}
